export function registerAnalytics() {
  document.addEventListener("click", (event) => {
    const target = event.target.closest("[data-fathom-event]")
    if (!target) return

    window.fathom?.trackEvent(target.dataset.fathomEvent)
  })
}
